<template>
    <div class="landing-wrapper bg-light min-vh-100 font-sans">
        <nav class="navbar navbar-expand-lg navbar-light bg-white py-3 shadow-sm sticky-top">
            <div class="container">
                <a class="navbar-brand d-flex align-items-center" href="#" style="padding: 0;">
                    <AppLogoDoacao class="nav-logo" />
                </a>
                <button class="navbar-toggler border-0" type="button" data-bs-toggle="collapse"
                    data-bs-target="#navbarNav">
                    <span class="navbar-toggler-icon"></span>
                </button>
                <div class="collapse navbar-collapse" id="navbarNav">
                    <ul class="navbar-nav ms-auto align-items-center gap-3 mt-3 mt-lg-0">
                        <li class="nav-item">
                            <a class="nav-link fw-medium text-dark hover-brand" href="#como-funciona"
                                @click.prevent="scrollTo('#como-funciona')">
                                Como Funciona
                            </a>
                        </li>
                        <li class="nav-item">
                           <a class="nav-link fw-medium text-dark hover-brand" href="#vantagens"
                                @click.prevent="scrollTo('#vantagens')">
                                Vantagens
                            </a>
                        </li>
                        <li class="nav-item">
                            <!-- Botão Entrar atualizado para o Azul Marinho do logo -->
                            <button class="btn btn-outline-brand-navy rounded-pill px-4 fw-bold w-100 w-lg-auto"
                                @click="goToLogin">
                                <i class="bi bi-box-arrow-in-right me-1"></i> Entrar
                            </button>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
        
        <section class="hero-section position-relative overflow-hidden pt-5 pb-5 text-center text-lg-start">
            <div class="container pt-4 pb-5">
                <div class="row align-items-center g-5">
                    <div class="col-lg-6 z-index-2">
                        <!-- Badge atualizada para tom de laranja amigável -->
                        <span
                            class="badge bg-orange-subtle text-brand-orange rounded-pill px-3 py-2 mb-3 fw-bold border border-orange-subtle">
                            <i class="bi bi-magic me-1"></i> Criador de Histórias com I.A.
                        </span>
                        <h1 class="display-4 fw-bolder text-dark mb-4" style="line-height: 1.2;">
                            <!-- Destaque visual usando o laranja do 'Pag' -->
                            Arrecade fundos para o que <span class="text-brand-orange">realmente importa.</span>
                        </h1>
                        <p class="lead text-secondary mb-4 pe-lg-4">
                            Crie sua vaquinha online em menos de 3 minutos. Nossa Inteligência Artificial escreve sua
                            história, e você aproveita as menores taxas do mercado para realizar seu objetivo.
                        </p>
                        <div
                            class="d-flex flex-column flex-sm-row gap-3 justify-content-center justify-content-lg-start">
                            <!-- Botão principal convertido para Laranja de alta conversão -->
                            <button class="btn btn-brand-orange rounded-pill px-5 py-3 fw-bold fs-5 shadow-lg pulse-btn"
                                @click="goToCreateCampaign">
                                Criar minha Vaquinha
                            </button>
                            <button class="btn btn-white rounded-pill px-4 py-3 fw-bold shadow-sm border text-brand-navy"
                                @click="scrollTo('#como-funciona')">
                                Saber mais
                            </button>
                        </div>
                        <div
                            class="d-flex align-items-center justify-content-center justify-content-lg-start mt-4 gap-3 text-muted small fw-medium">
                            <span><i class="bi bi-check-circle-fill text-success me-1"></i> Sem mensalidade</span>
                            <span><i class="bi bi-check-circle-fill text-success me-1"></i> Saque via PIX</span>
                        </div>
                    </div>
                    <div class="col-lg-6 position-relative z-index-2 text-center">
                        <div class="hero-image-wrapper p-4 bg-white rounded-4 shadow-lg border border-light mx-auto"
                            style="max-width: 500px; ">
                            <div class="d-flex align-items-center gap-3 mb-3 border-bottom pb-3">
                                <!-- Ícone IA usando o degradê do logo -->
                                <div class="bg-gradient-brand p-3 rounded-circle text-white"><i
                                        class="bi bi-robot fs-3"></i></div>
                                <div class="text-start">
                                    <h6 class="fw-bold mb-0">I.A. Gerando sua história...</h6>
                                    <span class="small text-muted">Texto magnético e persuasivo pronto!</span>
                                </div>
                            </div>
                            <div class="bg-light rounded-3 p-3 text-start mb-3"
                                style="font-size: 0.85rem; color: #475569;">
                                "Olá! Preciso muito da ajuda de vocês para realizar um sonho..." <span
                                    class="cursor-blink text-brand-orange">|</span>
                            </div>
                            <div class="progress" style="height: 8px;">
                                <div class="progress-bar progress-bar-striped progress-bar-animated bg-brand-orange"
                                    style="width: 100%"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Glow de fundo ajustado para o Laranja do logo -->
            <div class="position-absolute top-0 end-0 w-100 h-100 z-index-1 opacity-10"
                style="background: radial-gradient(circle at top right, #F25511 0%, transparent 40%); pointer-events: none;">
            </div>
        </section>

        <section id="como-funciona" class="py-5 bg-white">
            <div class="container py-5">
                <div class="text-center mb-5">
                    <h2 class="fw-bold text-dark">Como criar sua vaquinha?</h2>
                    <p class="text-muted">É rápido, intuitivo e com ajuda da tecnologia.</p>
                </div>

                <div class="row g-4 text-center">
                    <div class="col-md-4">
                        <div class="step-card p-4 rounded-4 h-100 transition-all border-hover-orange">
                            <div class="icon-box bg-orange-subtle text-brand-orange mx-auto mb-4 rounded-circle d-flex align-items-center justify-content-center"
                                style="width: 80px; height: 80px;">
                                <i class="bi bi-magic fs-1"></i>
                            </div>
                            <h5 class="fw-bold">1. A I.A. escreve para você</h5>
                            <p class="text-muted small mb-0">Diga em poucas palavras o seu objetivo. Nossa Inteligência
                                Artificial redige um texto emocionante e focado em doações.</p>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="step-card p-4 rounded-4 h-100 transition-all border-hover-orange">
                            <div class="icon-box bg-navy-subtle text-brand-navy mx-auto mb-4 rounded-circle d-flex align-items-center justify-content-center"
                                style="width: 80px; height: 80px;">
                                <i class="bi bi-share-fill fs-1"></i>
                            </div>
                            <h5 class="fw-bold">2. Compartilhe o Link</h5>
                            <p class="text-muted small mb-0">Sua página exclusiva fica pronta na hora. Envie no
                                WhatsApp, Instagram e Facebook para seus amigos e familiares.</p>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="step-card p-4 rounded-4 h-100 transition-all border-hover-orange">
                            <div class="icon-box bg-success-subtle text-success mx-auto mb-4 rounded-circle d-flex align-items-center justify-content-center"
                                style="width: 80px; height: 80px;">
                                <i class="bi bi-cash-stack fs-1"></i>
                            </div>
                            <h5 class="fw-bold">3. Receba via PIX, Boleto ou Cartão</h5>
                            <p class="text-muted small mb-0">Acompanhe as doações caindo em tempo real no seu painel e
                                solicite o saque direto para a sua conta bancária.</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section id="vantagens" class="py-5" style="background-color: #f8fafc;">
            <div class="container py-5">
                <div class="row align-items-center g-5">
                    <div class="col-lg-5">
                        <h2 class="fw-bold text-dark mb-4">Por que escolher o Dailypag?</h2>
                        <p class="text-secondary mb-4">Nós cortamos a burocracia e as taxas abusivas para que o dinheiro
                            doado vá para quem realmente precisa: <strong>você.</strong></p>

                        <ul class="list-unstyled mb-0">
                            <li class="d-flex mb-4">
                                <i class="bi bi-percent fs-3 text-success me-3"></i>
                                <div>
                                    <h6 class="fw-bold mb-1">A Menor Taxa do Mercado</h6>
                                    <p class="text-muted small mb-0">Enquanto outras plataformas cobram mais de 10%, nós
                                        garantimos a taxa mais justa para processar seus pagamentos.</p>
                                </div>
                            </li>
                            <li class="d-flex mb-4">
                                <i class="bi bi-lightning-charge-fill fs-3 text-brand-orange me-3"></i>
                                <div>
                                    <h6 class="fw-bold mb-1">Doações em Tempo Real</h6>
                                    <p class="text-muted small mb-0">Aceite PIX, Boleto e cartão. O doador pagou, o valor
                                        reflete imediatamente na barra de progresso da sua campanha.</p>
                                </div>
                            </li>
                            <li class="d-flex">
                                <i class="bi bi-shield-check fs-3 text-brand-navy me-3"></i>
                                <div>
                                    <h6 class="fw-bold mb-1">Transparência Total</h6>
                                    <p class="text-muted small mb-0">Painel administrativo completo para você gerenciar
                                        doadores, ver relatórios e solicitar saques com um clique.</p>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div class="col-lg-6 offset-lg-1">
                        <div class="bg-white p-2 rounded-4 shadow-lg border">
                            <div class="bg-light rounded-3 p-4 text-center" style="border: 2px dashed #cbd5e1;">
                                <i class="bi bi-bar-chart-fill text-muted fs-1 mb-2 d-block"></i>
                                <h5 class="fw-bold text-dark">Painel Financeiro Moderno</h5>
                                <p class="text-muted small">Gerencie tudo em um dashboard de alta performance.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="py-5">
            <div class="container py-5">
                <!-- Banner CTA usando o degradê oficial da marca (Laranja -> Roxo -> Azul) -->
                <div
                    class="bg-gradient-brand rounded-5 p-5 text-center text-white shadow-lg position-relative overflow-hidden">
                    <div class="position-relative z-index-2">
                        <h2 class="fw-bolder mb-3">Pronto para dar o primeiro passo?</h2>
                        <p class="lead mb-4 opacity-75 mx-auto" style="max-width: 600px;">
                            Não deixe para amanhã. Use o poder da Inteligência Artificial hoje mesmo e coloque sua
                            vaquinha no ar em minutos.
                        </p>
                        <button class="btn btn-light text-brand-orange rounded-pill px-5 py-3 fw-bold fs-5 shadow btn-hover-scale"
                            @click="goToCreateCampaign">
                            Começar Agora Gratuitamente
                        </button>
                    </div>
                    <i class="bi bi-stars position-absolute text-white opacity-25"
                        style="top: 20px; right: 40px; font-size: 5rem;"></i>
                    <i class="bi bi-balloon-heart-fill position-absolute text-white opacity-10"
                        style="bottom: -20px; left: 20px; font-size: 8rem;"></i>
                </div>
            </div>
        </section>

        <footer class="bg-white py-4 border-top text-center text-md-start">
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-md-6 mb-3 mb-md-0 d-flex align-items-center justify-content-center justify-content-md-start gap-2">
                        <AppLogoDoacao style="width: 90px; height: auto;" />
                        <span class="text-muted small border-start ps-2 border-2">© 2026 Todos os direitos reservados. CNPJ: 66.034.548/0001-60</span>
                    </div>
                    <div class="col-md-6 text-md-end text-muted small">
                        <a href="#" data-bs-toggle="modal" data-bs-target="#termsOfUseModal" class="text-decoration-none text-muted hover-brand"> Termos de Uso e Privacidade</a>
                    </div>
                </div>
            </div>
        </footer>
    </div>

    <!-- MODAL DE TERMOS DE USO E PRIVACIDADE -->
    <div class="modal fade" id="termsOfUseModal" tabindex="-1" aria-labelledby="termsOfUseModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
            <div class="modal-content border-0 shadow-lg rounded-4">
                <div class="modal-header border-0 pt-4 px-4 pb-3 bg-light rounded-top-4">
                    <h5 class="modal-title fw-bold text-dark d-flex align-items-center gap-2" id="termsOfUseModalLabel">
                        <i class="bi bi-shield-check text-brand-orange"></i> 
                        Termos de Uso e Política de Privacidade
                    </h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Fechar"></button>
                </div>
                <div class="modal-body p-4 text-secondary small" style="text-align: justify; line-height: 1.6;">
                    <p>Bem-vindo ao <strong>Dailypag</strong>. Ao utilizar nossa plataforma para criar campanhas de arrecadação ou realizar doações, você concorda integralmente com as regras e condições descritas abaixo.</p>
                    <!-- [Omiti o meio do texto do modal aqui para brevidade visual, mas mantenha o seu texto jurídico original] -->
                    <h6 class="fw-bold text-dark mt-4 mb-2">1. Política de Privacidade e Proteção de Dados (LGPD)</h6>
                    <p>Em conformidade com a Lei Geral de Proteção de Dados (Lei nº 13.709/2018), garantimos que seus dados pessoais (nome, CPF, e-mail, telefone e dados bancários) são coletados exclusivamente para fins de verificação de identidade, processamento de pagamentos, prevenção à fraude e cumprimento de obrigações legais. O Dailypag adota medidas rigorosas de segurança cibernética e não comercializa suas informações com terceiros. Você tem o direito de solicitar a exclusão de sua conta a qualquer momento, ressalvada a guarda de dados financeiros exigida pelo Banco Central do Brasil.</p>
                    <h6 class="fw-bold text-dark mt-4 mb-2">2. Regras e Condições para Saques</h6>
                    <p>Para garantir a segurança das transações e evitar fraudes financeiras, o processo de repasse dos valores arrecadados obedece estritamente às seguintes regras:</p>
                    <ul class="mb-3">
                        <li class="mb-1"><strong>Titularidade Obrigatória:</strong> Os saques só serão aprovados e transferidos para contas bancárias ou chaves PIX que possuam a <strong>exata mesma titularidade (mesmo CPF/CNPJ)</strong> do usuário cadastrado como criador da página de arrecadação. Transferências para contas de terceiros são expressamente proibidas.</li>
                        <li class="mb-1"><strong>Valor Mínimo:</strong> O valor mínimo exigido para a solicitação de qualquer saque na plataforma é de <strong>R$ 10,00</strong> (dez reais). Saldos inferiores a este montante deverão aguardar novas arrecadações para atingirem o limite mínimo.</li>
                        <li class="mb-1"><strong>Prazo de Processamento:</strong> Uma vez solicitado no painel, o repasse financeiro será analisado e creditado na conta do usuário no prazo de <strong>2 a 3 dias úteis</strong>.</li>
                    </ul>
                    <h6 class="fw-bold text-dark mt-4 mb-2">3. Conduta do Usuário e Responsabilidade das Campanhas</h6>
                    <p>O criador da campanha é o único e exclusivo responsável pela veracidade das informações, histórias, fotos e promessas divulgadas em sua página. O Dailypag atua apenas como intermediador tecnológico e financeiro. É terminantemente proibido criar campanhas para fins ilícitos, enganosos, que promovam discurso de ódio, violência ou que infrinjam direitos de terceiros.</p>
                    <h6 class="fw-bold text-dark mt-4 mb-2">4. Penalidades e Banimento da Plataforma</h6>
                    <p>O descumprimento de qualquer uma das regras estabelecidas nestes Termos de Uso, bem como a suspeita de fraude, lavagem de dinheiro, falsidade ideológica ou violação de direitos, acarretará no <strong>banimento imediato e definitivo do usuário da plataforma</strong>. Nestes casos, o Dailypag reserva-se o direito de reter os fundos arrecadados para devolução aos doadores originais ou para cumprimento de ordens judiciais, além de reportar o caso às autoridades competentes.</p>
                    <h6 class="fw-bold text-dark mt-4 mb-2">5. Alterações dos Termos</h6>
                    <p>A plataforma reserva-se o direito de modificar estes Termos de Uso a qualquer momento, sendo as alterações comunicadas aos usuários ativos via e-mail ou aviso no painel administrativo.</p>
                </div>
                <div class="modal-footer border-0 p-3 bg-light rounded-bottom-4 d-flex justify-content-end">
                    <button type="button" class="btn btn-secondary px-4 fw-medium" data-bs-dismiss="modal">Fechar</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AppLogoDoacao from '@/components/AppLogoDoacao.vue';

export default {
    name: 'PlatformLanding',
    components: {
        AppLogoDoacao
    },
    methods: {
        goToLogin() {
            this.$router.push('/login');
        },
        goToCreateCampaign() {
            this.$router.push('/login');
        },
        scrollTo(selector) {
            const element = document.querySelector(selector);
            if (!element) return;

            const headerOffset = 85; 
            const elementPosition = element.getBoundingClientRect().top;
            const startPosition = window.scrollY || window.pageYOffset;
            const targetPosition = elementPosition + startPosition - headerOffset;
            const distance = targetPosition - startPosition;
            const duration = 500; 
            let startTime = null;

            const easeInOutCubic = (t) => t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;

            function animation(currentTime) {
                if (!startTime) startTime = currentTime;
                const timeElapsed = currentTime - startTime;
                const progress = Math.min(timeElapsed / duration, 1);
                const easeProgress = easeInOutCubic(progress);

                window.scrollTo(0, startPosition + (distance * easeProgress));

                if (timeElapsed < duration) {
                    window.requestAnimationFrame(animation);
                }
            }

            window.requestAnimationFrame(animation);
        }
    }
}
</script>

<style scoped>
html {
    scroll-behavior: smooth !important;
}

section[id] {
    scroll-margin-top: 85px;
}

.landing-wrapper {
    overflow-x: clip;
}

.font-sans {
    font-family: 'Inter', system-ui, -apple-system, sans-serif;
}

/* --- Novas Cores da Marca Baseadas no Logo --- */
.text-brand-orange { color: #F25511 !important; }
.text-brand-navy { color: #0B081F !important; }

.bg-brand-orange { background-color: #F25511 !important; }
.bg-orange-subtle { background-color: #ffebe6 !important; }
.bg-navy-subtle { background-color: #e6e5eb !important; }

/* Degradê inspirado no ícone em formato de D */
.bg-gradient-brand {
    background: linear-gradient(135deg, #F25511 0%, #6B17A6 50%, #0B081F 100%) !important;
}

/* --- Botões Customizados --- */
.btn-brand-orange {
    background-color: #F25511;
    color: #fff;
    border: none;
    transition: all 0.3s ease;
}

.btn-brand-orange:hover {
    background-color: #D6450A;
    color: #fff;
    transform: translateY(-2px);
    box-shadow: 0 10px 20px rgba(242, 85, 17, 0.25) !important;
}

.btn-outline-brand-navy {
    color: #0B081F;
    border: 2px solid #0B081F;
    background: transparent;
    transition: all 0.3s ease;
}

.btn-outline-brand-navy:hover {
    background-color: #0B081F;
    color: #fff;
}

.hover-brand:hover {
    color: #F25511 !important;
}

.btn-hover-scale {
    transition: transform 0.2s ease, box-shadow 0.2s ease;
}
.btn-hover-scale:hover {
    transform: scale(1.05);
    box-shadow: 0 10px 25px rgba(0,0,0,0.2) !important;
}

/* --- Utilitários --- */
.z-index-1 { z-index: 1; }
.z-index-2 { z-index: 2; }

/* --- Animações --- */
.pulse-btn {
    animation: pulseOrange 2s infinite;
}

@keyframes pulseOrange {
    0% { box-shadow: 0 0 0 0 rgba(242, 85, 17, 0.4); }
    70% { box-shadow: 0 0 0 15px rgba(242, 85, 17, 0); }
    100% { box-shadow: 0 0 0 0 rgba(242, 85, 17, 0); }
}

.cursor-blink {
    animation: blink 1s step-end infinite;
    font-weight: bold;
}

@keyframes blink {
    50% { opacity: 0; }
}

/* --- Cards --- */
.step-card {
    background: white;
    border: 1px solid #f1f5f9;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
}

.step-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1);
}

.border-hover-orange:hover {
    border-color: #ffebe6;
}

.nav-logo {
    width: 280px;
    height: auto;
    display: block;
}

:deep(.nav-logo svg),
:deep(.nav-logo img) {
    width: 100% !important;
    height: auto !important;
}
</style>